import clsx from "clsx";
import styles from "../StructuredPromptImageCanvas.module.scss";

interface KeypointsTabContentProps {
	keypoints: Array<{ name: string; x: number; y: number }>;
	hoveredName: string | null;
	onHover: (name: string | null) => void;
}

export const KeypointsTabContent = ({ keypoints, hoveredName, onHover }: KeypointsTabContentProps) => {
	return (
		<div className={styles.keypointScrollList}>
			{keypoints.map((kp) => {
				const isHovered = hoveredName === kp.name;
				return (
					<div
						key={kp.name}
						className={clsx(styles.keypointRow, { [styles.keypointRowHovered]: isHovered })}
						onMouseEnter={() => onHover(kp.name)}
						onMouseLeave={() => onHover(null)}
					>
						<div
							className={clsx(styles.keypointIndicatorDot, {
								[styles.keypointIndicatorDotHighlighted]: isHovered,
							})}
						/>
						<span className={styles.keypointLabel}>{kp.name}</span>
					</div>
				);
			})}
		</div>
	);
};
